/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCustomMetricConfigurationSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCustomMetricConfigurationSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCustomMetricConfigurationSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCustomMetricConfigurationSync>): BackgroundJobPayloadForCustomMetricConfigurationSync {
        let obj = Object.assign(new BackgroundJobPayloadForCustomMetricConfigurationSync(), model);
        BackgroundJobPayloadForCustomMetricConfigurationSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCustomMetricConfigurationSync>): BackgroundJobPayloadForCustomMetricConfigurationSync {
        if (!model) return null;
        return BackgroundJobPayloadForCustomMetricConfigurationSync.newInstance(<BackgroundJobPayloadForCustomMetricConfigurationSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCustomMetricConfigurationSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForCustomMetricConfigurationSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCustomMetricConfigurationSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCustomMetricConfigurationSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud Account Id for which custom metric configuration sync to be triggered.
     */
    service_account_id: string;

    /**
     * In case of a specific metric configuration update, the id has to be added in payload
     */
    metric_configuration_id: string;

}
